module.exports = __webpack_public_path__ + "assets/img/14.b7354366.png";